<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <dialog-table-page ref="cashinDetailTable" :pageData="cashinPageData"></dialog-table-page>
    <dialog-table-page ref="tradeDetailTable" :pageData="tradePageData"></dialog-table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Url from '@/views/crs36/util/url'
  import dialogTablePage from '@/components/page/dialogTable.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  import Qs from 'qs'
  let activeList = {1:"激活",2:"未激活"}
  export default {
    name: 'user',
    components: {
      tablePage,
      FORM,
      UPDATE,
      dialogTablePage,
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "cashin"){
         //净入金
          this.cashinPageData.sync = true;
          let data = {type:3,luckyDrawId:row.luckyDrawId,account:row.account};
          this.$refs.cashinDetailTable.defaultQueryData(data);
        }else if (clickName == "trade"){
          //净入金
          this.tradePageData.sync = true;
          let data = {type:4,luckyDrawId:row.luckyDrawId,account:row.account};
          this.$refs.tradeDetailTable.defaultQueryData(data);
        }else if (clickName == "update"){
          row.luckyDrawCount = 0;
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if(window.$t('crs36.bt.export') == clickName ){
          const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:false});
          download.exportExcel(Url.luckyDraw.user.export,param,"参与用户");
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        this.dataChanage(Url.luckyDraw.user.updateLuckyUserNum,model,res => {
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
            this.$refs.childTable.defaultGetData(this.queryData);
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      },
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: "luckyDrawId", field: 'luckyDrawId',hidden:true},
            { title: "account", field: 'account',hidden:true},
            { title: "增加抽奖次数", field: 'luckyDrawCount',type: 7},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: "活动ID", field: 'luckyDrawId',data:this.$route.query.luckyDrawId},
              { title: "用户账号", field: 'account'},
              {title: "开户时间",field: 'openTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startOpenTime', 'endOpenTime']},
              {title: "激活时间",field: 'activeTime',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startActivationTime', 'endActivationTime']},
              {title: "参与时间",field: 'time',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startTime', 'endTime']},
              {click: window.$t('crs36.bt.search'),auth:"crs36.lucky.user.query"},
              {click: window.$t('crs36.bt.export'),auth:"crs36.lucky.user.export"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.luckyDraw.user.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: "活动ID", field: 'luckyDrawId'},
              { title: "用户账号", field: 'account'},
              { title: "真实开户时间", field: 'openAccountTime'},
              { title: "激活时间", field: 'activationTime'},
              { title: "激活状态", field: 'activationStatus',render:(data,full)=>{
                  return activeList[data];
                }},
              { title: "拥有总抽奖次数", field: 'luckyDrawCount'},
              { title: "剩余总抽奖次数", field: 'luckyDrawCountOdd'},
              { title: "净入金", field: 'netProceeds',h5Click:"cashin"},
              { title: "交易手数", field: 'tradingHandNumber',h5Click:"trade"},
              { title: "创建时间", field: 'createDate'},
              { title: "更新时间", field: 'updateDate'},
              {title: window.$t('crs36.bt.operation'),width: 200,btnClick:[
                  {name: "修改抽奖次数",click:"update",type:"primary",icon:"el-icon-edit",auth:"crs36.lucky.user.update"},
                ]
              },
          ],
        },
        cashinPageData: {
          queryUrl: Url.luckyDraw.user.analyse, //请求路径和参数
          title: "入金详情",
          sync:false,
          isShow: false,
          sequence: true,
          cols: [
            { title: "用户账号", field: 'account'},
            { title: "消息id", field: 'messageId'},
            { title: "金额", field: 'result'},
            { title: "交易平台", field: 'tradePlatform'},
            { title: "时间", field: 'time',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
          ],
        },
        tradePageData: {
          queryUrl: Url.luckyDraw.user.analyse, //请求路径和参数
          title: "交易详情",
          sync:false,
          isShow: false,
          sequence: true,
          cols: [
            { title: "用户账号", field: 'account'},
            { title: "消息id", field: 'messageId'},
            { title: "手数", field: 'result'},
            { title: "产品名称", field: 'product'},
            { title: "交易平台", field: 'tradePlatform'},
            { title: "时间", field: 'time',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
          ],
        },
      }
    }
  }
</script>
